module.exports = __webpack_public_path__ + "img/versapay-delivery-1.d3887bfb.png";